import * as Yup from 'yup';

const DATE_FORMAT_REGEX = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
const PHONE_NUMBER_FORMAT_REGEX = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;

const vendorProgramSchema = Yup.object().shape({
  effectiveStartDate: Yup.string()
    .required('Effective start date cannot be left blank')
    .matches(
      DATE_FORMAT_REGEX,
      'Effective start date is invalid'
    ),
  contact: Yup.string()
    .matches(
      PHONE_NUMBER_FORMAT_REGEX,
      'Phone number is invalid'
    ),
  description: Yup.string().required('Description cannot be left blank'),
  vendorId: Yup.string().required('Please select a vendor point'),
  categoryCode: Yup.string().required('Please select a category')
});

export default vendorProgramSchema;
